import { Link } from "@mui/material";
import { TFunction } from "i18next";
import RichText from "components/basic/richText";
import P from "pages/components/LegalParagraph";
import Bullets from "pages/components/LegalList";
import { PLACEHOLDER } from "pages/privacy/constants";
import { PolicySection } from "pages/privacy/content";

// Keep in step with VENDOR_AGREEMENT in ev-server/src/constants.ts, which
// records the version each vendor accepted during onboarding.
export const AGREEMENT_VERSION = 2;
export const AGREEMENT_LAST_UPDATED = "2026-10-25";

export const agreementSections = (t: TFunction<"legal">): PolicySection[] => [
  {
    id: "scope",
    title: t("agreement.scope.title"),
    body: (
      <>
        <P>{t("agreement.scope.p1", PLACEHOLDER)}</P>
        <P>
          <RichText
            t={t}
            i18nKey="agreement.scope.p2"
            components={{
              link1: <Link href="/terms" />,
              link2: <Link href="/privacy" />,
            }}
          />
        </P>
      </>
    ),
  },
  {
    id: "verification",
    title: t("agreement.verification.title"),
    body: <P>{t("agreement.verification.p1")}</P>,
  },
  {
    id: "compliance",
    title: t("agreement.compliance.title"),
    body: (
      <>
        <P>{t("agreement.compliance.p1")}</P>
        <Bullets
          items={[
            t("agreement.compliance.b1"),
            t("agreement.compliance.b2"),
            t("agreement.compliance.b3"),
            t("agreement.compliance.b4"),
          ]}
        />
        <P>{t("agreement.compliance.p2")}</P>
      </>
    ),
  },
  {
    id: "listings",
    title: t("agreement.listings.title"),
    body: <P>{t("agreement.listings.p1")}</P>,
  },
  {
    id: "quotes",
    title: t("agreement.quotes.title"),
    body: (
      <>
        <P>{t("agreement.quotes.p1")}</P>
        <Bullets
          items={[
            t("agreement.quotes.b1"),
            t("agreement.quotes.b2"),
            t("agreement.quotes.b3"),
            t("agreement.quotes.b4"),
          ]}
        />
      </>
    ),
  },
  {
    id: "customer-data",
    title: t("agreement.customer_data.title"),
    body: <P>{t("agreement.customer_data.p1")}</P>,
  },
  {
    id: "portal",
    title: t("agreement.portal.title"),
    body: <P>{t("agreement.portal.p1")}</P>,
  },
  {
    id: "work",
    title: t("agreement.work.title"),
    body: <P>{t("agreement.work.p1")}</P>,
  },
  {
    id: "fees",
    title: t("agreement.fees.title"),
    body: <P>{t("agreement.fees.p1")}</P>,
  },
  {
    id: "reviews",
    title: t("agreement.reviews.title"),
    body: <P>{t("agreement.reviews.p1")}</P>,
  },
  {
    id: "suspension",
    title: t("agreement.suspension.title"),
    body: <P>{t("agreement.suspension.p1")}</P>,
  },
  {
    id: "indemnity",
    title: t("agreement.indemnity.title"),
    body: <P>{t("agreement.indemnity.p1")}</P>,
  },
  {
    id: "liability",
    title: t("agreement.liability.title"),
    body: <P>{t("agreement.liability.p1")}</P>,
  },
  {
    id: "changes",
    title: t("agreement.changes.title"),
    body: <P>{t("agreement.changes.p1")}</P>,
  },
  {
    id: "law",
    title: t("agreement.law.title"),
    body: <P>{t("agreement.law.p1")}</P>,
  },
  {
    id: "contact",
    title: t("agreement.contact.title"),
    body: (
      <P>
        <RichText
          t={t}
          i18nKey="agreement.contact.p1"
          values={PLACEHOLDER}
          components={{ link1: <Link href={`mailto:${PLACEHOLDER.email}`} /> }}
        />
      </P>
    ),
  },
];
